import { useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import DOMPurify from "dompurify";
import styles from "./CancelImportantInfo.module.scss";

const ComponentName = "CancelImportantInfo";

export const CancelImportantInfo = ({ items }: { items?: string[] }) => {
  const { t } = useI18nContext();
  const [block, cn] = useModuleBEM(styles, ComponentName);

  if (!items?.length) {
    return null;
  }

  return (
    <section className={block}>
      <h2 className={cn("title")}>{t("selfServe.importantInformation")}</h2>
      <ol className={cn("list")}>
        {items.map((item, i) => (
          <li
            key={i}
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item) }}
          />
        ))}
      </ol>
    </section>
  );
};
